import React from 'react';

import { Confirmation } from './common';
import { UserIntegrateTable } from '../tables/UserIntegrateTable';
import { messageUtility } from '../../utilities/messageUtility';

export const ConfirmChangeIntegratedEmailDialog = ({
  visible,
  onConfirm,
  onCancel,
  data,
  action,
  cancelButtonText = messageUtility.getMessage('I-000-008'),
  confirmButtonText = '変更',
  title = 'ユーザーID（メールアドレス）の変更',
}) => {
  const getMessage = () => {
    return (
      <div>
        <div className='user-integrate__description'>
          このアカウントは下記のアカウントと統合されています。
          <br />
          このアカウントのメールアドレスを変更すると、統合済のアカウント全てのメールアドレスが変更されます。
          <br />
          またユーザーID（メールアドレス）を変更すると自動的にログアウトします。変更後のIDで再度ログインしてください。
          <br />
          ユーザーIDを変更しますか？
        </div>
        <UserIntegrateTable data={data} action={action} maxHeightTable={362} />
      </div>
    );
  };

  return (
    <React.Fragment>
      <Confirmation
        message={getMessage()}
        rootClassName='user-integrate'
        title={title}
        cancelButtonText={cancelButtonText}
        confirmButtonText={confirmButtonText}
        visible={visible}
        onCancel={onCancel}
        onConfirm={onConfirm}
      />
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmChangeIntegratedEmailDialog.jsx